import React from "react";
import SectionWrapper from "../layout/SectionWrapper";

export default function About() {
  return (
    <SectionWrapper id="about" className="relative bg-transparent backdrop-blur-none px-8 py-28 border-t border-white/10 text-left">
      <div className="max-w-4xl mx-auto z-10">
        <h2 className="text-left text-4xl sm:text-5xl font-bold font-geist tracking-tight text-white mb-6">
          About Me
        </h2>

        <p className="text-slate-400 font-inter text-lg sm:text-xl leading-relaxed mb-6 text-left max-w-3xl">
          I care about systems — clean, reliable, and built to adapt.
          <br /><br />
          I'm a backend-leaning engineer who builds with FastAPI, Spring Boot, React, and Docker. Lately, I’ve been threading AI into systems where it makes sense — with an eye on modularity, latency, and scale.
          <br /><br />
          Everything here is work-in-progress, just like the systems I build.
        </p>

        <div className="flex flex-wrap gap-2 mt-4">
          <span className="bg-cyan-700 text-cyan-100 px-3 py-1 rounded-full text-sm font-semibold backdrop-blur-sm border border-white/10">
            FastAPI
          </span>
          <span className="bg-slate-800 text-slate-100 px-3 py-1 rounded-full text-sm font-semibold backdrop-blur-sm border border-white/10">
            Docker
          </span>
          <span className="bg-violet-900 text-violet-100 px-3 py-1 rounded-full text-sm font-semibold backdrop-blur-sm border border-white/10">
            Spring Boot
          </span>
          <span className="bg-cyan-900 text-cyan-100 px-3 py-1 rounded-full text-sm font-semibold backdrop-blur-sm border border-white/10">
            React
          </span>
        </div>
      </div>
    </SectionWrapper>
  );
}
